var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgClosetheatremode = function SvgClosetheatremode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "theatre mode off_icon",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 132",
    d: "M30.527 36.347H8.398a3.41 3.41 0 01-3.406-3.407V22.72h14.1l11.434 13.625zm5.24-1.533L25.62 22.72h10.713v10.22a3.389 3.389 0 01-.566 1.874zm.564-13.458h-9.226l2.181-5.45h6.368a.682.682 0 01.681.681v4.768zm-23.21 0H4.993v-3.654l-1.264-4.993A2.043 2.043 0 015.26 10.22l1-.238-.015-.023 1.8-.406 4.766 5.68-2.476.563.076.112h2.966l1.305 1.555-1.558 3.893zm10.212-1.362l-3.428-4.085h5.062l-1.634 4.085zm-3.411-5.729L15.65 7.979l5.1-1.211 4.7 6.24-5.522 1.256zm8.745-2.251L24.34 5.789l3.794-.992.247-.058.055-.014 4.277-1.014a2.033 2.033 0 01.452-.051 2.072 2.072 0 011.992 1.547l1.16 4.4a.694.694 0 01-.076.527.682.682 0 01-.432.311l-3.2.727.041.063-3.978.779z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1880",
    width: 3,
    height: 46,
    rx: 1.5,
    transform: "rotate(-40 8.775 -4.756)",
    fill: "#fff"
  })));
};
export default SvgClosetheatremode;